import React, { Suspense, lazy } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, Col } from "antd";
const { Meta } = Card;
export function Item(props) {
    const { id } = props;

    const style = {
        border: "dashed",

        width: "100%",
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // border: "1px solid black",
        margin: "10px 0",
        background: "white"
    };

    return <div style={style}>{id}</div>;
}
const SortableItem = (props) => {

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    const componentRender = (component_name) => {
        const Component = lazy(() => import(`./${component_name}`))
        // const Component = lazy(() => import(`./components/LuzCard`))
        // if (componentData.blog_type_id === 3) {
        // console.log(componentData)
        // console.log(componentData?.title)
        // console.log(componentData?.content)
        // console.log(componentData?.blog_id)
        // console.log(Component)
        //component_json測資

        // let componentJson = {
        //     Title: componentData?.title,
        //     Goodtext: componentData?.content,
        //     blog_id: componentData?.blog_id,
        //     setRestart: setRestart
        // }
        return (
            <Col span={24} ref={setNodeRef} style={style} {...attributes} {...listeners}>

                <Suspense fallback={<div>Loading...</div>}>
                    <Component />
                    {/* <Component
                //     {...componentJson}
                //     // Title={componentData?.title}
                //     // Goodtext={componentData?.content}
                //     // blog_id={componentData?.blog_id}
                //     // setRestart={setRestart}
                //     src={componentData?.file_id?.length === 0 ? 'https://www.zdnet.com/a/img/resize/606a9ca71f882962abfe2ef0e6977b297f02bee3/2022/10/21/0c3e64f9-fb96-4f51-8a21-b45cb1fc5423/13a1b041-ce1e-46ff-90d7-b9b9c9a3f4bb.jpg?auto=webp&fit=crop&height=900&width=1200' : componentData?.file_url}
                // /> */}
                </Suspense>
            </Col>

        )
        // }
    }

    if (props.type === "component") {
        return (
            <Col ref={setNodeRef} style={style} {...attributes} {...listeners}>
                <Card
                    cover={
                        <img
                            alt="example"
                            src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
                        />
                    }
                >
                    <Meta id={props.id} title={props.name} />
                </Card>
                {/* <Item id={props.id} /> */}
            </Col>
        );
    }
    else {
        return componentRender(props.name)
        // (
        //     <Col ref={setNodeRef} style={style} {...attributes} {...listeners}>
        //         <Card
        //             cover={
        //                 <img
        //                     alt="example"
        //                     src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
        //                 />
        //             }
        //         >
        //             <Meta id={props.id} title={props.name} />
        //         </Card>
        //         {/* <Item id={props.id} /> */}
        //     </Col>
        // );
    }
}

export default SortableItem;
